<template>
  <div class="page_ table_textc">
    <div>
      <a-form layout="inline">
        <a-form-item label="保单号 ">
          <a-input
            class="min_input_"
            style="width: 200px;"
            v-model="policyNoi"
            placeholder="请输入保单号"
          ></a-input>
        </a-form-item>
        <a-form-item label="投保日期">
          <a-range-picker
            :placeholder="['请选择日期', '请选择日期']"
            style="width: 215px;"
            @change="rangeDate"
            :value="createValue"
          ></a-range-picker>
        </a-form-item>
        <a-form-item label="投保人">
          <a-input class="min_input_" v-model="holderNamei"></a-input>
        </a-form-item>
        <a-form-item label="被保人">
          <a-input class="min_input_" v-model="insuredNamei"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="searchData()">查询</a-button>
          <a-button style="margin-left: 8px;" type="default" @click="initData()"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>
    <a-table
      style="margin-top: 17px;"
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      @change="handlePageChange"
      class="table_b table_nowrap table_nowrapg"
    >
      <span slot="operation" slot-scope="text, record" class="span_btn">
        <a @click="correct(record.id)">批改</a>
      </span>
    </a-table>
    <div class="fixbg1" v-if="isLoagding">
      <a-spin />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/utils/api";
import { getLogined, getToken, getUserInfo } from "@/utils/authorized";
const columns = [
  {
    title: "保单号",
    key: "policyNo",
    dataIndex: "policyNo",
  },
  {
    title: "产品名称",
    key: "productName",
    dataIndex: "productName",
  },
  {
    title: "保费",
    key: "totalPremium",
    dataIndex: "totalPremium",
  },
  {
    title: "投保人",
    key: "name",
    dataIndex: "name",
  },
  {
    title: "起保日期",
    key: "effectiveDate",
    dataIndex: "effectiveDate",
  },
  {
    title: "终保日期",
    key: "expireDate",
    dataIndex: "expireDate",
  },
  {
    title: "操作",
    key: "do",
    scopedSlots: { customRender: "operation" },
  },
];

export default {
  data() {
    document.title = "保单批改";
    return {
      columns,
      tableData: [],
      pagination: {
        total: 0,
        pageSize: 10,
        pageNum: 1,
      },
      createValue: [],
      policyNo: "",
      status: 1,
      pageNum: "1",
      pageSize: "10",
      isLoagding: false,
      policyNoi: "",
      startDatei: "",
      endDatei: "",
      holderNamei: "",
      insuredNamei: "",
      showCorrect: false,
      dateFormat: "YYYY-MM-DD",
      step: 1,
      salInsuredList: [],
      salPolicy: {},
      salPolicyHolder: {},
      idTypeOptions: [
        {
          name: "身份证",
          value: "1",
        },
        {
          name: "护照",
          value: "2",
        },
        {
          name: "台湾通行证",
          value: "6",
        },
        {
          name: "港澳通行证",
          value: "4",
        },
      ],
      sexOptions: [
        {
          value: "M",
          name: "男",
        },
        {
          value: "F",
          name: "女",
        },
      ],
      policyId: "",
      defaultDate: "",
      data: [],
    };
  },
  mounted() {
    if (getUserInfo() && getUserInfo().userName) {
      this.userName = getUserInfo().userName;
      this.initData();
    } else {
      this.$router.push({
        name: "gd-login",
      });
    }
  },
  methods: {
    moment,
    handlePageChange(e) {
      this.pageNum = e.current;
      this.searchData();
    },
    initData() {
      this.policyNoi = "";
      this.createValue = [];
      this.startDatei = "";
      this.endDatei = "";
      this.holderNamei = "";
      let queryData = {
        userName: this.userName,
        startIndex: this.pageNum,
        pageSize: 10,
      };
      this.queryData(queryData);
    },
    queryData(queryData) {
      this.isLoagding = true;
      api
        .queryGdPolicy(queryData)
        .then((res) => res.data)
        .then((data) => {
          this.isLoagding = false;
          this.data = data.policyList;
          this.tableData = [];
          data.policyList.map((item, index) => {
            if (item.policyInfo.status === "1") {
              this.tableData.push({
                ...item.policyInfo,
                effectiveDate: moment(item.policyInfo.effectiveDate).format(
                  "YYYY-MM-DD"
                ),
                expireDate: moment(item.policyInfo.expireDate).format(
                  "YYYY-MM-DD"
                ),
                key: index,
                name: item.policyHolder.name,
              });
            }
          });
          this.pagination.total = data.total;
        })
        .catch((error) => {
          this.isLoagding = false;
          this.errorMsg = error.data.msg || "";
        });
    },
    searchData() {
      let queryData = {
        startIndex: this.pageNum,
        pageSize: 10,
        status: this.status,
        policyNo: this.policyNoi,
        startDate: this.startDatei,
        endDate: this.endDatei,
        holderName: this.holderNamei,
        insuredName: this.insuredNamei,
        userName: this.userName,
      };
      this.queryData(queryData);
    },
    rangeDate(dates, dateStrings) {
      this.createValue = dates;
      this.startDatei = dateStrings[0];
      this.endDatei = dateStrings[1];
    },
    correct(policyId) {
      console.log(policyId, ";policyId--");
      let itemData = this.data.filter(
        (item) => item.policyInfo.id === policyId
      )[0];
      console.log(itemData, this.data, "this.data----");
      localStorage.setItem("correctData", JSON.stringify(itemData));

      if (itemData.policyInfo.policyType === "2") {
        this.$router.push({ path: `/gd/modify/${policyId}` });
      } else {
        this.$router.push({ path: `/gd/modifyP/${policyId}` });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.min_input_ {
  width: 64px;
}
.span_btn {
  a {
    color: #ff4c1c;
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.fixbg_ {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100vh;
  .fixcon {
    background-color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 960px;
    margin: 0 auto;
    max-height: 50vh;
    overflow-y: hidden;
    padding-top: 50px;
    top: 50%;
    transform: translateY(-50%);
    & > p {
      font-weight: bold;
      font-size: 16px;
      height: 50px;
      line-height: 50px;
      margin: 0;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      margin: 0 auto;
      padding: 0 20px;
    }
    .close_ {
      width: 30px;
      height: 30px;
      background: url(../../../assets/wxmall/closeicon.png) center center
        no-repeat;
      background-size: 30px 30px;
      position: absolute;
      right: 20px;
      top: 10px;
      cursor: pointer;
    }
    .detail {
      position: absolute;
      left: 0;
      right: 0;
      padding: 0 20px;
      bottom: 50px;
      top: 50px;
      overflow-y: scroll;
      & > p {
        font-weight: bold;
      }
    }
    .forminfo_ {
      display: flex;
      flex-direction: row;
      .infoitem {
        display: flex;
        flex: 1;
        margin-bottom: 20px;
        input {
          border: 1px solid #d9d9d9;
          background-color: transparent;
          width: 95px;
          padding-left: 5px;
          height: 32px;
          line-height: 32px;
          border-radius: 4px;
        }
        select {
          width: 100px;
          height: 32px;
          line-height: 32px;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
        span {
          white-space: nowrap;
          margin-right: 5px;
          width: 65px;
          text-align: left;
          height: 30px;
          line-height: 30px;
        }
      }
    }
    .btn_b {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50px;
      padding-bottom: 10px;
      display: flex;
      justify-content: center;
      button {
        width: 100px;
        height: 40px;
        line-height: 40px;
        background-color: #ff4c1c;
        color: #fff;
        text-align: center;
        border: none;
        outline: none;
        border-radius: 4px;
        display: block;
        font-size: 16px;
        padding: 0;
        cursor: pointer;
        &:first-child {
          margin-right: 40px;
        }
      }
    }
  }
}
.itemright {
  position: relative;
}
.selectmask {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 5;
  left: 0;
  right: 0;
  background-color: transparent;
  width: 100% !important;
}
.table_b {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.fixbg1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  .ant-spin-spinning {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    left: 0;
    margin: auto;
  }
}
</style>
